import { TmaEvent, TrackingModel } from "../../models/models"
import { TmaSender } from "../tma-sender"
import { VehicleDetailsFormCall } from "./models"

export class VehicleDetailsFormCallEventHandler extends TmaSender<VehicleDetailsFormCall> implements TmaEvent {
    key = "VEHICLE_DETAILSFORMCALL"

    static serviceEndpoint = "/vehicles/vehicleDetailsFormCall"

    constructor() {
        super(VehicleDetailsFormCallEventHandler.serviceEndpoint)

        this.requestBody = {}
    }

    handle = (trackingData: TrackingModel<VehicleDetailsFormCall>): boolean => {
        if (!trackingData.payload) {
            return false
        }

        const { vehicleId } = trackingData.payload

        if (trackingData.tmaEvent && trackingData.tmaEvent === this.key && vehicleId && trackingData.bundle === "general") {
            if (Array.isArray(trackingData.action)) {
                trackingData.action.forEach((action) => this.fillRequest(vehicleId, action))
            } else {
                this.fillRequest(vehicleId, trackingData.action)
            }

            return false
        }

        return false
    }

    fillRequest = (vehicleId: string, action: string) => {
        if (action === "details-form-call") {
            if (vehicleId) {
                this.requestBody.vehicleId = vehicleId
            }

            this.sendEvent()
        }
    }
}
